<template>
  <div>
    <b-row>
      <b-col cols="2" xl="1">
        <md-button class="md-raised" @click="refresh" >{{$t('Refresh')}}</md-button>
      </b-col>
      <b-col cols="1" xl="1">
        <md-button class="md-raised" @click="synchronizeAll" >{{ $t('Synchronize all') }}</md-button>
      </b-col>
    </b-row>

    <basic-table
        v-if="tv24SyncSubscriptions"
        :items="tv24SyncSubscriptions"
        :fields="fields"
        @ClickOnEditButton="synchronizeOne"
        :isDelete="false"
        :isEdit="true"/>
    <table-manager-bottom-small
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <userInfo :userInfo="selectedUser"/>
    <modalAdd24TVUser :editItem="addUserData"/>
  </div>
</template>

<script>
import userInfo from './userInfo'
import modalAdd24TVUser from './modalAdd24TVUser'

export default {
  components: {
    userInfo,
    modalAdd24TVUser
  },
  data () {
    return {
      fields: [
        {key: 'id', label: '24TV ID', sortable: true},
        {key: 'user_id', label: this.$i18n.t('User ID'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'email', label: this.$i18n.t('Email'), sortable: true},
        {key: 'subscriptions',
          label: this.$i18n.t('Total subscriptions'),
          sortable: true,
          formatter: (val, key, item) => {
            return item.subscriptions.length
          }},
        {key: 'subscriptions_connected',
          label: this.$i18n.t('With service connected'),
          sortable: true,
          formatter: (val, key, item) => {
            return item.subscriptions_connected.length
          }},
        {key: 'subscriptions_not_connected',
          label: this.$i18n.t('Not found connected service'),
          sortable: true,
          formatter: (val, key, item) => {
            return item.subscriptions_not_connected.length
          }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      perPage: 20,
      totalRows: 10000,
      currentPage: 1,
      selectedUser: null,
      addUserData: null
    }
  },
  methods: {
    paginationChanged (value) {
      this.perPage = value
    },
    refresh () {
      this.currentPage = 1
      this.$store.dispatch('Settings/GET_TV_24_SYNC_SUBSCRIPTIONS', {'limit': this.perPage,
        'offset': (this.currentPage - 1) * this.perPage})
    },
    realSynchronizeAll () {
      this.$store.dispatch('Settings/POST_TV_24_SYNC_ALL_SUBSCRIPTIONS')
      this.$root.$emit('makeToasts')
      setTimeout(this.refresh, 2000)
    },
    realSynchronizeOne (item) {
      this.$store.dispatch('Settings/POST_TV_24_SYNC_SUBSCRIPTIONS', item.user_id)
      this.$root.$emit('makeToasts')
      setTimeout(this.refresh, 2000)
    },
    synchronizeOne (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to synchronize customer services?', this.realSynchronizeOne, item)
    },
    synchronizeAll () {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to synchronize all services?', this.realSynchronizeAll, null)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_CHAT_SETTINGS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_CHAT_SETTINGS')
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  watch: {
    currentPage (val) {
      this.$store.dispatch('Settings/GET_TV_24_SYNC_SUBSCRIPTIONS', {'limit': this.perPage,
        'offset': (val - 1) * this.perPage})
    },
    perPage (val) {
      this.$store.dispatch('Settings/GET_TV_24_SYNC_SUBSCRIPTIONS', {'limit': val,
        'offset': (this.currentPage - 1) * val})
    }
  },
  computed: {
    tv24SyncSubscriptions () {
      return this.$store.getters['Settings/TV_24_SYNC_SUBSCRIPTIONS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_TV_24_SYNC_SUBSCRIPTIONS', {'limit': this.perPage,
      'offset': (this.currentPage - 1) * this.perPage})
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/subscriptions.vue